import { css } from "@emotion/css";
import { CircularProgress } from "@octopusdeploy/design-system-components";
import { CheckCircleIcon, XmarkCircleIcon } from "@octopusdeploy/design-system-icons";
import { borderRadius, fontSize, space, themeTokens } from "@octopusdeploy/design-system-tokens";
import classNames from "classnames";
const styles = {
    box: css({
        padding: `${space[12]} ${space[16]}`,
        alignSelf: "stretch",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        fontSize: fontSize.medium,
        color: themeTokens.color.text.primary,
        borderRadius: borderRadius.small,
        gap: space[16],
    }),
    waiting: css({
        backgroundColor: themeTokens.color.callout.background.info.default,
    }),
    success: css({
        backgroundColor: themeTokens.color.callout.background.success.default,
    }),
    failure: css({
        backgroundColor: themeTokens.color.callout.background.danger.default,
    }),
    contentContainer: css({
        display: "flex",
        alignItems: "center",
        gap: space[6],
    }),
    progressContainer: css({
        display: "flex",
        height: "24px",
        width: "24px",
        padding: "4px",
        alignItems: "center",
        justifyContent: "center",
    }),
};
type AnnotationsVerificationStatusProps = {
    status: "waiting" | "failure" | "success";
};
export const AnnotationsVerificationStatus = (props: AnnotationsVerificationStatusProps) => {
    const { status } = props;
    if (status === "waiting") {
        return (<div className={classNames(styles.box, styles.waiting)} role="alert">
                <div className={styles.contentContainer}>
                    <div className={styles.progressContainer}>
                        <CircularProgress size="container" aria-hidden="true"/>
                    </div>
                    <span>Verifying if annotations have been added to your Argo CD application YAML...</span>
                </div>
            </div>);
    }
    if (status === "failure") {
        return (<div className={classNames(styles.box, styles.failure)} role="alert">
                <div className={styles.contentContainer}>
                    <XmarkCircleIcon size={24} color={themeTokens.color.icon.danger}/>
                    <span> Failed to verify annotations. Copy the annotations below to your Argo CD application.</span>
                </div>
            </div>);
    }
    if (status === "success") {
        return (<div className={classNames(styles.box, styles.success)} role="alert">
                <div className={styles.contentContainer}>
                    <CheckCircleIcon size={24} color={themeTokens.color.icon.success}/>
                    <span> Annotations have been successfully added to your Argo CD YAML.</span>
                </div>
            </div>);
    }
    return <></>;
};
